import { useTreeStore } from '@/frontend/store/TreeStore';
import { ContainerTreeObject } from '@/frontend/types/navigationTypes';
import { I18n } from '@/i18n/I18n';
import { useEffect, useState } from 'react';
import { CollapseButton } from '../buttons/CollapseButton';
import { StepRun } from './StepRun';
import { Step } from '@/backend/models/containers/step';

export function SectionRun(props: { section: ContainerTreeObject }) {
  const { section } = props;
  const { container, children } = section;
  const observer = useTreeStore((state) => state.observer);
  const [showSection, setShowSection] = useState(true);

  useEffect(() => {
    const observedItem = document.getElementById(`${section.id}`);
    if (observer && observedItem) {
      observer.observe(observedItem as HTMLElement);
    }
    return () => {
      if (observer && observedItem) {
        observer.unobserve(observedItem as HTMLElement);
      }
    };
  });

  return (
    <li className="card observed-element" id={`${section.id}`}>
      <div className="mb-3 card-header">
        <div className="d-flex justify-content-between">
          <div className='d-flex align-items-center'>
            <CollapseButton showElement={showSection} setShowElement={setShowSection} title={I18n.get('section')} />
            <h5 className='mb-0 pe-2'>{section.wbs}</h5>
            <h5 className='mb-0'>{container.title}</h5>
          </div>
        </div>
      </div>
      { showSection && <div className="">
        <div className="card-body">
          { container.description && <p style={{whiteSpace: 'pre-wrap'}} className='px-3 pb-3'>{container.description}</p> }
          <ul className="list-group gap-2">
            {children.map(child => {
              return (
                <div className="ms-3 me-3 mb-3" key={`container-run-${child.id}`}>
                  { child.container instanceof Step && <StepRun stepId={child.id} /> }
                  { child.container.isSection() && <SectionRun section={child} /> }
                </div>
              );
            })}
          </ul>
        </div>
      </div> }
    </li>
  );
};
